<template>
  <div
    data-testid="workflow-review-status-reviewers"
    :class="containerClass"
    class="tw-flex"
  >
    <div v-if="hasAnyUpToDateReview" class="tw-w-full">
      <span class="tw-block tw-truncate">
        {{ I18n.t('reconciliation_review.reviewed_by') }}
        <span v-for="(review, idx) in reviewsToShow" :key="review.name">
          <span class="sf-font-bold">{{ review.name }}</span
          ><span v-if="idx < reviewsToShow.length - 1">, </span>
        </span>
      </span>
    </div>

    <div v-else>
      <span class="tw-block tw-truncate">
        {{ previouslyReviewedLabel }}
      </span>
    </div>

    <!-- <h5>44444</h5> -->
  </div>
</template>

<script lang="ts" setup>
import useI18n from '@app/shared/vue/composables/use-I18n'
import { computed } from 'vue'
import type { TemplateReview } from '@app/application/workflows/types'
import { getPreviouslyReviewedLabel } from '@app/application/workflows/utils/format-preparation-and-review'

const I18n = useI18n()

interface Props {
  hasAnyUpToDateReview: boolean
  hasUpToDateReviewByUser: boolean
  reviewsToShow: Array<TemplateReview>
}

const props = defineProps<Props>()

const containerClass = computed(() => {
  return {
    'tw-text-emerald-600': props.hasUpToDateReviewByUser,
  }
})

const previouslyReviewedLabel = computed(() =>
  getPreviouslyReviewedLabel(props.reviewsToShow)
)
</script>
